/**
 * Signature re-capture — phone confirmation callable (PF-6119).
 *
 * Region and app match every other callable in this repo (`firebaseConfig.ts`), even though this
 * route never signs the visitor into Firebase Auth. The request and response shapes come from
 * `@physiofit-digital/physiofit_types`, so this wrapper cannot drift from the function it calls.
 */
import type {
  VerifySignatureRecapturePhoneRequest,
  VerifySignatureRecapturePhoneResponse,
} from '@physiofit-digital/physiofit_types';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../../../firebaseConfig';

export const verifySignatureRecapturePhone = (data: VerifySignatureRecapturePhoneRequest) =>
  httpsCallable<VerifySignatureRecapturePhoneRequest, VerifySignatureRecapturePhoneResponse>(
    functions,
    'verifySignatureRecapturePhone',
  )(data).then((r) => r.data);
